import { render, staticRenderFns } from "./TextStyle.vue?vue&type=template&id=2a7204ee&"
import script from "./TextStyle.vue?vue&type=script&lang=js&"
export * from "./TextStyle.vue?vue&type=script&lang=js&"
import style0 from "./TextStyle.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports